<kendo-switch [readonly]="readonly" [size]="size" [disabled]="disabled" [checked]="checked" (blur)="onBlur()" (focus)="onFocus()" (valueChange)="valueChanged($event)"></kendo-switch>
